export default {
  badge: 'Setting up',
  title: 'Finish setting up your restaurant',
  description: 'A few steps remain before your restaurant can go live.',
  count: '{{done}} of {{total}} steps done',
  cta: 'Continue setup',
  done: {
    badge: 'All set',
    title: "You're all set",
    description: '{{partner}} will take your restaurant live.',
    fallback_partner: 'Your provider',
  },
};
